// @flow
import ko from 'knockout';
import _ from 'lodash';

ko.extenders.properties = (target, customProperties) => {
	customProperties = _.mapValues(customProperties, property => {
		if (!ko.isObservable(property) && _.isFunction(property)) {
			return ko.pureComputed(() => {
				return property.call(target, target());
			});
		}

		return property;
	});
	return _.extend(target, customProperties);
};
